// Shared sign-coded percentage formatting for contribution/adjustment views
// (model explorer page + the feature contributions dialog).

export const signedPct = value => {
  if (value == null) {
    return null
  }
  return `${value > 0 ? '+' : ''}${Number(value).toFixed(1)} %`
}

// Sign-coded color for a ± percentage: green raise, red cut, gray ≈ neutral.
export const pctColor = value => {
  if (value == null || Math.abs(value) < 0.05) {
    return 'text-gray-400'
  }
  return value > 0 ? 'text-green-600' : 'text-red-600'
}
